import { cssPrefix } from '../../const/Constant';
import { Widget } from '../../lib/Widget';

class ELContextMenuDivider extends Widget {

  constructor() {
    super(`${cssPrefix}-el-context-menu-item-divider`);
  }

}

export { ELContextMenuDivider };
